










import Vue from 'vue'
import XDropdown, {
  OptionEntry,
} from '@/components/atoms/Dropdown/XDropdown.vue'
import { Query, StoreShippingAddress } from '@/types/generated/graphql'
import STORE_ADDRESS_LIST_QUERY from '@/graphql/partner/allStoreShippingAddresses.gql'

type Methods = {
  onChange: (v: Props['value']) => void
}

type Data = {
  addresses?: StoreShippingAddress[]
}

type Computed = {
  options: OptionEntry<string>[]
}

type Props = {
  value?: string
  storeId: string
}

export default Vue.extend<Data, Methods, Computed, Props>({
  inheritAttrs: false,
  name: 'StoreAddressPicker',
  components: { XDropdown },
  props: {
    value: {
      type: String,
      required: false,
    },
    storeId: {
      type: String,
      required: false,
    },
    // ...rest (inherit attrs from x-dropdown)
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)

      const address = this.addresses?.find(
        (address) => address.storeShippingAddressId === value
      )
      this.$emit('select', address)
    },
  },
  computed: {
    options() {
      return (
        this.addresses?.map((address) => ({
          value: address.storeShippingAddressId,
          label: address.name,
        })) || []
      )
    },
  },
  apollo: {
    addresses: {
      query: STORE_ADDRESS_LIST_QUERY,
      variables() {
        return { storeId: this.storeId }
      },
      update(data: Query) {
        this.$emit('load:done', data.allStoreShippingAddresses)
        return data.allStoreShippingAddresses
      },
      skip() {
        return !this.storeId
      },
    },
  },
})
